const getKeyByValue = (object: Record<string, string>, value: string): string | undefined => {
    return Object.keys(object).find(
        (key) => Object.prototype.hasOwnProperty.call(object, key) && object[key] === value
    );
};

export { getKeyByValue };
